module.exports = __webpack_public_path__ + "img/new_slide_1.43eeebcf.jpg";